import { forwardRef } from "react";

/** Labeled input with inline error display. Works with Formik field props. */
export const Input = forwardRef(function Input(
  { label, name, error, touched, className = "", ...props },
  ref
) {
  const showError = touched && error;
  return (
    <div className="mb-4">
      {label && (
        <label htmlFor={name} className="block mb-2 text-foreground">
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={name}
        name={name}
        className={`w-full rounded-md border border-input bg-background p-2 text-foreground focus:border-ring focus:ring-1 focus:ring-ring ${className}`}
        {...props}
      />
      {showError && <p className="mt-1 text-sm text-destructive">{error}</p>}
    </div>
  );
});

export default Input;
